var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2 pb-0"},[_c('h3',[_vm._v(_vm._s(_vm.heading))]),_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")]),(_vm.action)?_c('div',{staticClass:"mt-2",attrs:{"align":"right"}},[_c('v-btn',{on:{"click":function($event){return _vm.performAction()}}},[_vm._v(_vm._s(_vm.action))])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }